import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

import KPI from '../../../../components/KPI/KPI.vue'
import Loading from '../../../../components/Loading/Loading.vue'
import { SmartProcessingAuditViewModel } from '../models/SmartProcessingAudit.viewmodel'
import { useMessages } from '../../../../composables/useMessages'
import i18n from '../../../../VueI18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartProcessingAuditPanel',
  props: {
    viewModel: null
  },
  setup(__props: any) {

const props = __props as { viewModel: SmartProcessingAuditViewModel };



const vm = computed(() => props.viewModel)
const audit = computed(() => props.viewModel.selectedAudit.value)

const graficoIndisponivel = ref(false)
const { addMessage } = useMessages()

// O PNG e por variavel: trocar de variavel tem que dar nova chance ao <img>,
// senao o primeiro erro de carregamento esconderia todos os graficos seguintes.
watch(
	() => props.viewModel.selectedInterestVariable.value,
	() => {
		graficoIndisponivel.value = false
	},
)

function avisaCopia(description: string) {
	addMessage({
		title: i18n.t('sucesso') as string,
		description,
		icon: 'far fa-check-circle',
		type: 'success',
	})
}

function copiarEquacao() {
	if (!audit.value) return

	navigator.clipboard.writeText(audit.value.adjustedModelLatex)
	avisaCopia(i18n.t('equacaoCopiadaParaAreaDeTransferencia') as string)
}

function copiarBeta(coefficient: number) {
	navigator.clipboard.writeText(String(coefficient))
	avisaCopia(i18n.t('betaCopiadoParaAreaDeTransferencia') as string)
}

/**
 * TSV com virgula decimal para colar direto no Excel pt-BR -- mesmo formato que
 * o "Copiar Todos" do AboutModel dos modelos hipsometricos entrega.
 */
function copiarTodosOsBetas() {
	if (!audit.value) return

	const linhas = audit.value.adjustedModelCoefficients.map(
		(coefficient, i) =>
			`${audit.value?.coefficientLabels[i]}\t${String(coefficient).replace('.', ',')}`,
	)

	navigator.clipboard.writeText(linhas.join('\n'))
	avisaCopia(i18n.t('betasCopiadosParaAreaDeTransferencia') as string)
}

return { __sfc: true,props, vm, audit, graficoIndisponivel, addMessage, avisaCopia, copiarEquacao, copiarBeta, copiarTodosOsBetas, KPI, Loading }
}

})